import { render } from "./CourseSummary.vue?vue&type=template&id=3e6c4b54"
import script from "./CourseSummary.vue?vue&type=script&lang=js"
export * from "./CourseSummary.vue?vue&type=script&lang=js"

import "./CourseSummary.vue?vue&type=style&index=0&id=3e6c4b54&lang=scss"

import exportComponent from "/Users/gardener/OpenideProjects/Navigator_frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__